import React from 'react';

export default function Checkbox({
	checked = false,
	indeterminate = false,
	className = ''
}) {
	const stateClass = checked
		? 'is-checked'
		: indeterminate
			? 'is-indeterminate'
			: '';

	return (
		<span
			className={`ats-checkbox ${stateClass} ${className}`.trim()}
			aria-hidden="true">
			{checked ? (
				<img src="/ats/icons/check-white-icon.svg" alt="" />
			) : indeterminate ? (
				<span className="ats-checkbox__indeterminate" />
			) : null}
		</span>
	);
}
